import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { LOGIN_VALIDATION } from "../../../helpers/validations/authValidation/authValidationSchema";
import { Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../redux/actions/alertActions/alertActions";
import PasswordVisibility from "../auth-components/PasswordVisibility";
import { UnviewIcon, ViewIcon } from "../auth-components/PasswordIcon";
import { setLoader } from "./../../../redux/actions/loaderActions/loadActions";
import { loginAction } from "../../../redux/actions/loginActions/loginActions";
import AuthFooterContent from "../auth-components/AuthFooterContent";
import { requestErrorMessage } from "../../../constants/messages-constants";

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigator = useNavigate();
  const { state } = useLocation();
  const { email } = state ?? "";
  const { showpassword, handleShowPassword } = PasswordVisibility();

  let InitialValues = {
    email: email || "",
    password: "",
  };
  const handleSubmit = async (values) => {
    dispatch(setLoader(true));
    dispatch(loginAction(values))
      .then((response) => {
        dispatch(setLoader(false));
        if (response?.data?.errorCode === 0) {
          navigator("/");
          dispatch(showAlert(response.data.message, "success", true));
        }
      })
      .catch((error) => {
        dispatch(setLoader(false));
        dispatch(
          showAlert(
            error?.response?.data?.message ?? requestErrorMessage.SOMETHING_WENT_WRONG,
            "danger",
            true
          )
        );
      });
  };

  return (
    <>
      <div className="auth-pages">
        <div className="auth-container">
          <h4 className="text-uppercase mb-8">Log Into Your Account</h4>
          <p className="text-grey">
            Mi lorem scelerisque accumsan orci bibendum ultrices ultricies
            suspendisse.
          </p>
          <div className="mt-40">
            <Formik
              validationSchema={LOGIN_VALIDATION}
              onSubmit={handleSubmit}
              initialValues={{ ...InitialValues }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
                isValid,
                dirty,
              }) => (
                <Form className="formstyle" onSubmit={handleSubmit}>
                  <Form.Group className="mb-24">
                    <p className="mb-8 fw-semi-bold">Email</p>

                    <Form.Control
                      type="text"
                      id="email"
                      name="email"
                      className={`input ${
                        touched.email && errors.email && "input-border"
                      }`}
                      placeholder="Enter Email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />

                    {touched.email && errors.email ? (
                      <p className="error mt-8">{errors.email}</p>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="mb-24">
                    <p className=" mb-8 fw-semi-bold">Password</p>
                    <div className="showicon">
                      <Form.Control
                        type={showpassword.password1 ? "text" : "password"}
                        id="password"
                        name="password"
                        value={values.password}
                        onBlur={handleBlur}
                        className={`input ${
                          touched.password && errors.password && "input-border"
                        }`}
                        placeholder="Enter Password"
                        onChange={handleChange}
                      />
                      {showpassword.password1 ? (
                        <ViewIcon onClick={() => handleShowPassword(1)} />
                      ) : (
                        <UnviewIcon onClick={() => handleShowPassword(1)} />
                      )}
                    </div>
                    {touched.password && (
                      <p className="error mt-8">{errors.password}</p>
                    )}
                  </Form.Group>
                  <Button
                    className="btn-primary w-100 mt-16 mb-40"
                    type="submit"
                    disabled={!(isValid && dirty)}
                  >
                    Sign In
                  </Button>
                  <div>
                    <p className="text-light-grey">
                      <Link to="/forgot-password" className="navigation-link">
                        Forgot your password?
                      </Link>
                    </p>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <AuthFooterContent />
      </div>
    </>
  );
};

export default LoginForm;
